import React from 'react';
import TagManager from '../components/tags/TagManager';

const TagsPage = () => {
  return (
    <div className="px-2 sm:px-3 lg:px-4 py-4">
      <TagManager />
    </div>
  );
};

export default TagsPage;
